import { useEffect, useState } from "react";
import { loadCommonShiftSchedules } from "./shiftEarningsApi";

export const useShiftSchedules = (domain, employeeCodes, enabled) => {
  const codesKey = JSON.stringify([...new Set(employeeCodes.filter(Boolean))].sort());
  const key = JSON.stringify([domain, codesKey, enabled]);
  const [result, setResult] = useState(null);
  const [retry, setRetry] = useState(0);
  const active = Boolean(enabled && domain && codesKey !== "[]");
  useEffect(() => {
    if (!active) return;
    const controller = new AbortController();
    setResult(null);
    loadCommonShiftSchedules(domain, JSON.parse(codesKey), controller.signal)
      .then((schedules) => { if (!controller.signal.aborted) setResult({ key, schedules, error: "" }); })
      .catch((error) => { if (!controller.signal.aborted) setResult({ key, schedules: [], error: error.message }); });
    return () => controller.abort();
  }, [active, codesKey, domain, key, retry]);
  const current = active && result?.key === key ? result : null;
  return { schedules: current?.schedules || [], error: current?.error || "", loading: active && !current, retry: () => setRetry((n) => n + 1) };
};
